import { calcImageUrl, getWidthByHeight } from '../../util/image/pickImageByRatio';

import { RhinoImage } from './types';
import { useImageTypeRatio } from './useImageTypeRatio';

export type ImageSettings = {
  imageHeight: number;
  imageType?: number;
};

export type ImageData = {
  url?: string;
  width: number;
  height: number;
  originalUrl?: string;
};

function getAssetImage(image: RhinoImage | null | undefined, height: number, ratio?: string) {
  if (!image && ratio) {
    return {
      width: getWidthByHeight(height, ratio),
      height,
    };
  }

  if (!image) {
    return { height: 0, width: 0 };
  }

  const width = getWidthByHeight(height, image.ratio);

  return {
    url: calcImageUrl(image.url, height, width),
    width,
    height,
  };
}

/**
 * @deprecated Please use getAssetImageUrl
 */
export function createAssetImage(images: RhinoImage[], options: { height: number; type: number; ratio: string }) {
  const image = images.find((image) => image.type === options.type);

  if (!image) {
    return { height: 0, width: 0 };
  }

  const width = getWidthByHeight(options.height, image.ratio);

  return {
    url: calcImageUrl(image.url, options.height, width),
    width,
    height: options.height,
  };
}

/**
 * @deprecated Please use getAssetImageUrl
 */
export const useAssetImage = (images: RhinoImage[], imageSettings: ImageSettings): ImageData => {
  const height = imageSettings.imageHeight;
  const image = images.find((image) => image.type === imageSettings.imageType);
  // @ts-expect-error TODO Fix
  const imageRatio = useImageTypeRatio(imageSettings.imageType);

  return getAssetImage(image, height, imageRatio);
};
